import {UI} from "../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../PanelPage";
import {iFrameState} from "../../../services/IFrameState";
import {PoweredByBlink} from "../../PoweredByBlink";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {PanelLoginFooterBuilder, PromptInlineUserDashboard} from "../../panel-elements/LoginFooter";
import {PanelText} from "../../panel-elements/PanelText.jsx";
import {PanelActionButtonBuilder} from "../../panel-elements/ActionButton";
import {SubscribeFlowController} from "../../flows/SubscribeFlowController";
import {DonateFlowController} from "../../flows/DonateFlowController";
import {PaywallPurchaseFlowController} from "../../flows/PaywallPurchaseFlowController.jsx";
import {CloseController, LinkController} from "../../flows/BasicFlowControllers";
import {IdentityFlowController} from "../../flows/IdentityFlowController";
import {StyleElement} from "../../../../stem-core/src/ui/StyleElement";
import {NewsletterFlowController} from "../../flows/NewsletterFlowController";
import {PanelCloseButton} from "../../PanelCloseButton";
import {MerchantLogo} from "../../../common/MerchantLogo";
import {GiftSubscriptionFlowController} from "../../flows/GiftSubscriptionFlowController";
import {convertToUI} from "../../../widget/ui/MessageElement";
import {PanelLink} from "../../panel-elements/PanelLink.jsx";
import {PanelImage} from "../../panel-elements/PanelImage.jsx";


export const panelClassMap = new Map([
    ...[
        "div", "span", "p", "i", "nav",
        "strong", "em", "br", "b", "hr",
        "ul", "ol", "li", "code", "var",
        "h1", "h2", "h3", "h4", "h5", "h6",
        "input", "label",
        "parsererror", // This is to nicely display errors generated by DOMParser.parseFromString.
    ].map(tag => ([tag, UI.Primitive(tag)])),
    ["If", UI.Primitive("div")],
    ["Style", StyleElement],
    ["PanelLink", PanelLink], // Duplicate because of our current rendering engine (the DOM)
    ["Link", PanelLink],
    ["PanelImage", PanelImage],
    ["Text", PanelText],
    ["Logo", MerchantLogo],
    ["Close", PanelCloseButton],
    ["SubscribeButton", PanelActionButtonBuilder(SubscribeFlowController)],
    ["DonateButton", PanelActionButtonBuilder(DonateFlowController)],
    ["GiftSubscriptionButton", PanelActionButtonBuilder(GiftSubscriptionFlowController)],
    ["NewsletterButton", PanelActionButtonBuilder(NewsletterFlowController)],
    ["PurchaseButton", PanelActionButtonBuilder(PaywallPurchaseFlowController)],
    ["LinkButton", PanelActionButtonBuilder(LinkController)],
    ["CloseButton", PanelActionButtonBuilder(CloseController)],
    ["IdentityButton", PanelActionButtonBuilder(IdentityFlowController)],
    ["SubscribeLoginFooter", PanelLoginFooterBuilder(SubscribeFlowController)],
    ["DonateLoginFooter", PanelLoginFooterBuilder(DonateFlowController)],
    ["PurchaseLoginFooter", PanelLoginFooterBuilder(PaywallPurchaseFlowController)],
    ["PromptInlineUserDashboard", PromptInlineUserDashboard],
    ["PoweredByBlink", PoweredByBlink],
]);

class BasePanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    container = {
        padding: null,
        width: "100%",
    }

    @styleRuleInherit
    content = {
        width: null,
        padding: null
    }
}

@registerStyle(BasePanelStyle)
export class BasePanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            hasHeader: false,
        };
    }

    render() {
        return convertToUI(iFrameState.panelContent, panelClassMap);
    }
}
